import TuneIcon from "@mui/icons-material/Tune";
import styled from "styled-components";
import {GridViewSharp, ListSharp} from "@mui/icons-material";
import useIsMobile from "../../../helpers/isMobile";
import {useState} from "react";
import {FilterPanel} from "./filter-panel/FilterPanel";

export const SpanFilter = styled.span`
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--bs-secondary);
    padding-left: 3%;
`

export const ContainerBtn = styled.div`
    --color: ${(props) => props.background};

    .activeTab {
        background: var(--bs-primary);
        color: white;
    }
`

export const AccessStyle = styled.button`
    width: 3rem;
    height: 3rem;
    padding: 2px;
    background: none;
    color: var(--bs-primary);
    border: none;
`

export const FilterSection = ({ filterOptions, filter, viewMode, onFilterChange, onViewModeChange }) => {
    const isTablet = useIsMobile().isTablet;
    const [hide, setHide] = useState(isTablet);

    return (
        <div>
            <div className="mb-4 d-flex align-items-center justify-content-between">
                <div className="d-flex">
                    <TuneIcon style={{ color: 'var(--bs-secondary)' }} />
                    <SpanFilter>Filtros</SpanFilter>
                    {isTablet && (
                        <div className="form-check form-switch ms-2">
                            <input className="form-check-input" type="checkbox" role="switch" id="filterSwitch"
                                   checked={!hide} onChange={() => setHide(!hide)} />
                        </div>
                    )}
                </div>

                <ContainerBtn>
                    <AccessStyle
                        title="grid"
                        id="grid"
                        onClick={() => onViewModeChange('grid')}
                        className={`tab-button ${viewMode === 'grid' ? 'activeTab' : ''}`}>
                        <GridViewSharp style={{ fontSize: 35 }} />
                    </AccessStyle>
                    <AccessStyle
                        title="list"
                        id="list"
                        onClick={() => onViewModeChange('list')}
                        className={`tab-button ${viewMode === 'list' ? 'activeTab' : ''}`}>
                        <ListSharp style={{ fontSize: 35 }} />
                    </AccessStyle>
                </ContainerBtn>
            </div>

            {!hide && <FilterPanel filterOptions={filterOptions} filter={filter} onFilterChange={onFilterChange}/>}
        </div>
    );
};
